export default "__VITE_ASSET__Da8QQLpx__"